import { useSyncExternalStore } from 'react';

import { secondsUntil } from '../countdown';

import { secondTicker as second } from './secondTicker';

const idle = (): (() => void) => () => undefined;

export const useCountdown = (target: number | null): number => {
  const read = (): number => secondsUntil(target, second.getSnapshot());
  const subscribe = target === null || read() === 0 ? idle : second.subscribe;
  return useSyncExternalStore(subscribe, read, read);
};
